<template>
  <div>
    <Card>
      <ui-chip :selected="true">Chip</ui-chip>
    </Card>
    <Card>
      <ui-chip prepend-icon="far fa-random">Chip</ui-chip>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

</script>
